import { CoeWorkerUIModel } from "src/store/models/ui/coeWorks/coeWork";

export const CoeWorkerUIModels = {
  coeWork: CoeWorkerUIModel,
};
